import { TBTestMap, TBTestList, TBTest } from '../../../../types';
import ChecklistSection from '../../../atoms/checklist-section';
import Finger, { Status } from '../../../atoms/finger';
import { getVisible, getDocStatus } from '../../../../utilities/documents';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { useIsSectionLocked } from '../../../../hooks/useIsSectionLocked';
import { SectionId } from '../../../molecules/Sidebar/types';

interface IProps {
  infoOnly: boolean;
  documents: TBTestMap;
  warning?: string;
  onResume: (url: string) => void;
  onClick: (docKey: string, infoOnly: boolean) => void;
}

const TBTestHand = (props: IProps) => {
  const { documents: docs, infoOnly } = props;
  const offer = useSelector((state: ApplicationState) => state.student.offer);
  const isSectionLocked = useIsSectionLocked(SectionId.GENERAL_DOC, offer.status);

  const visibleDocs = getVisible(docs, infoOnly) as TBTestList[];

  if (visibleDocs.length === 0) return null;

  const isTBTestNotRequired = (doc: TBTest) => {
    const { isReturningUKResident, awayFromUKMoreThan2Yrs, hasLivedInExemptCountry, hasStayedInExemptCountry } =
      doc || {};
    return (
      (isReturningUKResident !== undefined &&
        hasLivedInExemptCountry !== undefined &&
        isReturningUKResident === true &&
        awayFromUKMoreThan2Yrs === false) ||
      (hasLivedInExemptCountry === true && hasStayedInExemptCountry === false)
    );
  };

  return (
    <ChecklistSection
      id={'tb-test-doc'}
      label={infoOnly ? `You will need to take a TB test` : `You will need to take a TB test and upload the results`}
      edit={() => {
        props.onResume('personal-info/step-3');
      }}
      warning={props.warning}
    >
      {visibleDocs.map((doc: TBTestList, index: number) => {
        const { key: docKey, item } = doc;
        const isTBTestNotReq = isTBTestNotRequired(item);
        if (item.status === 'REJECTED') {
          return (
            <Finger
              hideButton={true}
              reason={item.reason}
              key={`tb-test-${docKey}`}
              id={`tb-test-${docKey}`}
              status={Status.Rejected}
              label={`Tuberculosis Test Results ${visibleDocs.length > 1 ? (index > 0 ? index + 1 : '') : ''}`}
            />
          );
        } else {
          return (
            <Finger
              key={`tb-test-${docKey}`}
              id={`tb-test-${docKey}`}
              status={isTBTestNotReq ? Status.Complete : getDocStatus(item.status, infoOnly, isSectionLocked)}
              completeLabel={infoOnly ? 'View' : undefined}
              resolveLabel={infoOnly ? 'Please Confirm' : undefined}
              buttonLabel={infoOnly ? 'Please review' : undefined}
              label={`Tuberculosis Test Results ${visibleDocs.length > 1 ? (index > 0 ? index + 1 : '') : ''}`}
              onClick={() => props.onClick(docKey, infoOnly)}
            />
          );
        }
      })}
    </ChecklistSection>
  );
};

export default TBTestHand;
